export enum UserRole {
  admin = 'admin',
  ankerslotSales = 'ankerslot_sales',
  clientAdmin = 'client_admin',
  clientUser = 'client_user',
  customerUser = 'customer_user',
}
